import { render, staticRenderFns } from "./mfa.vue?vue&type=template&id=e47595ea&scoped=true"
import script from "./mfa.vue?vue&type=script&lang=js"
export * from "./mfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47595ea",
  null
  
)

export default component.exports